import * as React from "react";
import { useReducer, useEffect } from "react";
import { Row, Col, Button, Input } from 'reactstrap';
import GenericDropdown from './controls/GenericDropdown';
import { LookupItem } from "../Models/LookupItem";
import { ChapterArticle } from "../Models/ChapterArticle";
import ChaptersListingResults, { SearchFilter } from './ChaptersListingResult';
import FeaturedChapter from "./FeaturedChapter";
import * as Utils from '../Utils';
import { HashParams } from "./ChaptersListing";

type OrderBy = 'date' | 'alpha';

type ChaptersListingRedirectProps = {
    Categories: LookupItem[];
    Chapters: LookupItem[];
    YearMonths: LookupItem[];
    BackgroundImage: string;
    Title: string;
    ListingUrl: string;
}

type ChaptersListingRedirectState = {
    keywords: string;
    selectedCategory: LookupItem;
    selectedChapter: LookupItem;
    selectedYearMonth: LookupItem;
    redirectUrl: string;
}



const buildInitialState = (props: ChaptersListingRedirectProps) => {

    let initialState: ChaptersListingRedirectState = {
        keywords: '',
        selectedCategory: undefined,
        selectedChapter: (props.Chapters || []).length > 0 ? props.Chapters[0] : undefined,
        selectedYearMonth: undefined,
        redirectUrl: ''
    }

    return initialState;
}

const ChaptersListingRedirect = (props: ChaptersListingRedirectProps) => {

    const [state, setState] = useReducer(
        (prevState: ChaptersListingRedirectState, Chapterstate: Partial<ChaptersListingRedirectState>) => ({ ...prevState, ...Chapterstate }),
        buildInitialState(props)
    );

    const search = () => {

        const filter = getHashParams();

        window.location.href = state.selectedChapter.Value + Utils.buildHash(filter);
    };

    const getHashParams = () => {

        const filter: HashParams = {
            //chap: state.selectedChapter ? state.selectedChapter.Title : undefined,
            cat: state.selectedCategory ? state.selectedCategory.Title : undefined,
            ym: state.selectedYearMonth ? state.selectedYearMonth.Title : undefined,
            q: state.keywords.length > 0 ? state.keywords : undefined
        }

        return filter;
    }

    useEffect(() => {

        const filter = getHashParams();

        setState({ redirectUrl: props.ListingUrl + Utils.buildHash(filter) });

    }, [state.keywords, state.selectedCategory, state.selectedChapter, state.selectedYearMonth]);

    // return
    return <div className="chapters-listing">
        <div className="chapter-filters-wrapper" style={{ backgroundImage: `url(${props.BackgroundImage})` }}>
            <h1 className="title">{props.Title}</h1>
            <div className="inline-filters d-flex flex-md-row flex-column flex-sm-column">
                <div className="d-md-flex w-100">

                    <div className="dropdown-wrapper">
                        <div className="small dropdown-head-label">Select Chapter</div>
                        <GenericDropdown
                            dataSource={props.Chapters}
                            getId={x => x.Value}
                            renderItem={x => x.Title}
                            renderSelectedItem={x => x.Title}
                            nullSelectionText="All Chapters"
                            allowNullSelection={false}
                            selectedValue={state.selectedChapter ? state.selectedChapter.Value : undefined}
                            onSelectedItemChanged={x => setState({ selectedChapter: x })}
                        />
                    </div>

                    <GenericDropdown
                        dataSource={props.Categories}
                        getId={x => x.Value}
                        renderItem={x => x.Title}
                        renderSelectedItem={x => x.Title}
                        nullSelectionText="All Events"
                        allowNullSelection={true}
                        selectedValue={state.selectedCategory ? state.selectedCategory.Value : undefined}
                        onSelectedItemChanged={x => setState({ selectedCategory: x })}
                    />

                    <GenericDropdown
                        dataSource={props.YearMonths}
                        getId={x => x.Value}
                        renderItem={x => x.Title}
                        renderSelectedItem={x => x.Title}
                        nullSelectionText="All Dates"
                        allowNullSelection={true}
                        selectedValue={state.selectedYearMonth ? state.selectedYearMonth.Value : undefined}
                        onSelectedItemChanged={x => setState({ selectedYearMonth: x })}
                    />

                    <div className="search">
                        <form className="form-inline search-form">
                            <div className="input-group w-100">
                                <div className="search-icon">
                                    <i className="fas fa-search"></i>
                                </div>
                                <Input onChange={(e) => { setState({ keywords: e.target.value }) }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            search();
                                        }
                                    }}
                                    value={state.keywords}
                                    className="form-control"
                                    placeholder="Search for keywords and description" />

                                <Button onClick={search}>Search</Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

}

export default ChaptersListingRedirect;